module.exports = __webpack_public_path__ + "images/95152c9429ebfa0197ac610c744c45dc-yes_icon.png";